import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
  IFilterControl,
  SelectableOption,
} from '../../../types/internal-interfaces';
import { RadioButtonListConfig } from './radio-button-list-config';

@UntilDestroy()
@Component({
  selector: 'radio-button-list',
  templateUrl: './radio-button-list.component.html',
  styleUrls: ['./radio-button-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonListComponent implements OnInit, IFilterControl {
  @Input() configuration: RadioButtonListConfig;

  @Output() filterUpdated: EventEmitter<string> = new EventEmitter();

  optionSelected: UntypedFormControl = new UntypedFormControl();
  options: SelectableOption[] = [];

  constructor() {}

  ngOnInit(): void {
    this.configuration?.options.forEach((o: SelectableOption) =>
      this.options.push(o),
    );

    this.handleValueChanges();
  }

  public setValue(currentOptionValue: string): void {
    let selectedOption = this.options.find(
      (option: SelectableOption) => option.value === currentOptionValue,
    );

    if (!selectedOption) {
      selectedOption = this.configuration.defaultSelection;
    }

    this.optionSelected.setValue(selectedOption.value);
  }

  private handleValueChanges(): void {
    this.optionSelected.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((radioBtnSelectedVal: string) => {
        this.filterUpdated.emit(radioBtnSelectedVal);
      });
  }
}
